<template>
    <section id="third_page_cont" class="page_cont">
        <div id="team_container">
            
            {{ /*IF i is even img to right, else image to left*/ }}
            {{/*START CARD*/ }}

           <div class="container flex flex-col items-center justify-center p-4 mx-auto space-y-8 sm:p-10">
			<h1 class="text-4xl font-bold leadi text-center sm:text-5xl">Il nostro team</h1>
			<div class="card_metacont">
                <!-- <div v-for="(team_el,i) in this.team_els" :key="i.toString()+team_el.real_name" style="margin-left: 15%;" class="card_cont">
				<div class="team_card">
					<img alt="" class="team_img" :src="team_el.image">
					<p class="team_name">{{team_el.real_name}}</p>
					<p class="team_role">{{team_el.role}}</p>
                    <div class="card_social_cont">
                        <div class="for_social" v-for="(social_key,j) in Object.keys(team_el).filter(f=>f.includes('social_') && team_el[social_key]!=='')" :key="i.toString()+social_key+j.toString()">
                        <span  :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="team_el[social_key]!==''"> <a :href="team_el[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </span> 
                        </div>
                    </div>
				</div> **/ -->
                <div v-for="(team_el,i) in this.team_els" :key="i.toString()+team_el.real_name" class="card_cont">
				<div class="team_card" :id="team_el.real_name">
					<img alt="" class="team_img" :src="team_el.image">
					<p class="team_name">{{team_el.real_name}}</p>
                    <p class="phone_number">{{ team_el.phone }}</p>
					<p class="team_role" v-for="(role,i) in team_el.role.split(';')" :key="role+i.toString()">{{role}}</p>
                    <div class="card_social_cont">
                        <div class="for_social" v-for="(social_key,j) in Object.keys(team_el).filter(f=>f.includes('social_') && team_el[social_key]!=='')" :key="i.toString()+social_key+j.toString()">
                        <span  :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="team_el[social_key]!==''"> <a :href="team_el[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </span> 
                        </div>
                    </div>
				</div>
				
			</div>
            </div>
            
		</div>
           
            {{/*END CARD*/ }}
        </div>
        
    </section>
</template>

<script>
export default{
    name:"ThirdPage",
    props:{},
    data(){
        return{
            team_els:[],
            social_icons:{
                "facebook":"fa fa-facebook",
                "tiktok":"fa-brands fa-tiktok",
                "instagram":"fa fa-instagram",
                "twitter":"twitter"
            },

            static_team_els:[
                {"real_name":"Angeliana Anelli",
                "role":"Titolare Group animation & boing party;Responsabile animazione e allestimenti ",
                "phone":"345 8969522",
                "image":"team_angeliana.jpg",
                "social_facebook":"https://m.facebook.com/people/Angeliana-Anelli/1411803106/"

                },
                {"real_name":"Federica Venitucci",
                "role":"Responsabile di segreteria;Smistamento delle chiamate;Gestione di posta;Archiviazione di pratiche",
                "phone":"351 3926003",
                "image":"team_federica.jpg",
                },
                {"real_name":"Angeliana Capogna",
                "role":"Titolare HulaHoop;Responsabile gadget kit fine festa",
                "phone":"345 3518969",
                "image":"team_adriana.jpg"
                },
            ]
        }
    },
    mounted(){
        this.team_els= this.$parent.firebase_data["slides"]["team_els"]
        this.$parent.track_page("Team")

    },
    methods:{

    },
    watch:{

    }
}
</script>

<style scoped>
:root{
  --body_bg:rgba(255, 105, 105,0.6);
  --body_bg_dark:rgba(253, 221, 221, 0.507);
  text-shadow: var(--body_bg) 3px 1px 10px;

}
h1{
    color:var(--bs-danger);
    font-weight:bolder;
    font-size:40px!important
}

#third_page_cont{
    text-align: center;
}



.team_img{
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    background-position:center;
    align-self: center;
    vertical-align: middle;
    object-fit: cover;
    margin-top: -15%;
}

.card_metacont{
    display:flex;
    flex-direction: row;
    width: 90%;
    flex-wrap: wrap;
    position: absolute;
    margin-left: 1vw;
}


.team_card{
    display:flex;
    flex-direction: column;
    width: 20em;
    height: 13em;
    min-width: 10em ;
    background-color: white;
    border: 1px solid black;
    min-width: 100%;
    margin-top:25%;
    border-radius: 0.375rem;
   
}


.card_social_cont{
    display: flex;
    flex-direction: column;
    position: inherit;
    width: 1em;
    text-align:justify;
    justify-content: space-evenly;
    margin-left:290px;
    margin-top:-125px;

}

.for_social:first-of-type{
    margin-top: 0px;
}

.team_name{

    font-family:system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-weight: bolder;
    font-size: 1.3rem;
}

.team_role{
    font-family: italics;
    color: var(--bs-danger);

}



@media only screen and (max-width:1000px){
    .card_metacont{
       width:50%;
       margin-left: 15%;
    }
}

@media only screen and (max-width:700px){
    .card_metacont{
       width:50%;
       margin-left: 5%;
    }
}

@media only screen and (max-width:500px){
    .card_metacont{
       width:50%;
       margin-left: 7%;
       
    }

    .card_social_cont{
        margin-top:-40%!important
    }
}

@media(pointer:coarse){
    @media (orientation:landscape){
    .card_social_cont{
        margin-top: -40%!important;
    }
    .card_metacont{

    margin-left:17%
    }
    
    }
    @media (orientation:portrait){
        .card_social_cont{
            margin-top: -40%!important;

        }
        .card_metacont{
            margin-left: 5%!important;
        }
    } 
}




.for_social_sub{
  background-color: transparent;
  border-radius: 50%;
  width: 40px!important;
  text-align: center;
  border: rgb(248, 188, 188) 0px solid;

}

.for_social_sub_empty{
  display: none;
}

.for_social_sub > *> svg > path{
  fill: var(--bs-danger);
}

.card_cont{
    margin-right:7%;
}

</style>
